<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center">
            <div class="col-md-9 ps-5 pt-5 pb-4">
                <h2 class="col pb-2 title">
                    {{ "SIDEBAR_EVENTS" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "EVENTS_SUBTITLE" | translate }}</h6>
            </div>
        </div>

        <div class="row g-0 m-0">
            <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pb-3">
                <app-events-filter class="pe-2"
                [numberOfResults]="numberOfEvents"
                [selectedAssetTypes]="selectedFilters.assetTypes || []"
                [selectedEventChannels]="selectedFilters.channelIds || []"
                (applied)="onDataReceived($event)">
            </app-events-filter>

                <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
                <div class="datepicker-container-wrapper position-relative">
                    <div class="button-wrapper pe-2">
                        <div class="button">
                            <img alt="Date" src="assets/core/table-button/date.svg" />
                            <div class="button-text" (click)="toggleDatepicker()"
                                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                                    {{ selectedDate }}
                                </ng-container>
                                <ng-template #noDateSelected>
                                    <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                                </ng-template>
                            </div>
                            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                                src="assets/device/x.svg" (click)="clearDates()" />
                        </div>
                    </div>
                    @if (isDatepickerOpen) {
                    <div class="overlay" (click)="toggleDatepicker()"></div>
                    <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
                    }
                </div>
                <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)"></app-search>
            </div>
            <div class="row g-0 m-0">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "ENERGYREGISTERS_METERNO" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "EVENT_TYPE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "READTIME" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "INGESTIONTIME" | translate }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data; let i=index">
                            <td appIsNew [executedTime]="row.ingestionTime!" [seconds]="dayInMs"></td>
                            <td>
                                <span (click)="clipboardService.copyToClipboard(row.meterNo!, $event, i)"
                                    class="copyable">
                                    {{ row.meterNo }}
                                    <span class="copy-tooltip"
                                        *ngIf="clipboardService.copiedText === i.toString()">{{"COPIED" |
                                        translate}}</span>
                                </span>
                            </td>
                            <td>
                                <span class="label-box" [ngStyle]="{
                                    'background-color': getAlertColor(row.channelId || '-')
                                    }">{{ row.channelId }}</span>
                            </td>
                            <td>
                                <span>{{ row.assetType }}</span>
                            </td>
                            <td>
                                <span>{{
                                    row.readOnMeterTime | date: "dd MMMM yyyy hh:mm a"
                                    }}</span>
                            </td>
                            <td>
                                <span>{{
                                    row.ingestionTime | date: "dd MMMM yyyy hh:mm a"
                                    }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="container-down">
            <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfEvents" [pageSize]="pageSize"
                [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
        </div>
    </div>
</div>
